export default __webpack_public_path__ + "static/media/pro-elevate-gry-banner-2.2443733f.jpg";